import { Col }from 'react-bootstrap';

import { Clipboard2CheckFill, StopwatchFill, GraphUp, Newspaper, Brush, EnvelopePaper, Eyeglasses } from 'react-bootstrap-icons';


interface ContentProps{
    title: string;
    subtitle: string;
    text: string;
    invert?: boolean;
}

function TitleBlock({title, subtitle, text, invert=false}: ContentProps){
    return (
        <> 

                    <Col md className="">

                        {(title === "art") && <h1><Brush className="color-font-primary" size={32} /></h1> }
                        {(title === "mission") && <h1><EnvelopePaper className="color-font-primary" size={32} /></h1> }
                        {(title === "vision") && <h1><Eyeglasses className="color-font-primary" size={32} /></h1> }
                        {(title === "clipboard") && <h1><Clipboard2CheckFill size={32} /></h1> }
                        {(title === "clock") && <h1><StopwatchFill size={32} /></h1> }
                        {(title === "chart") && <h1><GraphUp size={32} /></h1> }
                        {(title === "publication") && <h1><Newspaper size={32} /></h1> }
                        <h3 className={"text-start font-body font-size-large " + (invert ? "color-font-secondary" : "color-font-primary")}>{subtitle}</h3>
                        <p className={"text-start font-body font-size-small " + (invert ? "color-font-secondary" : "color-font-primary")}>{text}</p>
                    </Col>


        </>
    )
}

export default TitleBlock;